export default {
  DARK: {
    title: p => p.accentWhite,
    price: p => p.primaryLight,
    paragraph: p => p.accentWhite,
    link: p => p.primaryLight,
    iconText: p => p.primaryLight,
    background: p => `${p.tertiaryDark}`,
    lightBackground: p => p.tertiaryExtraLight,
    icon: p => p.primaryLight,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    title: p => p.tertiaryDark,
    price: p => p.primaryDark,
    link: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    iconText: p => p.primaryDark,
    background: p => `${p.tertiaryLight}`,
    lightBackground: p => p.tertiaryExtraLight,
    icon: p => p.primaryDark,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    title: p => p.tertiaryDark,
    price: p => p.primaryDark,
    link: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    iconText: p => p.primaryDark,
    background: p => `${p.tertiaryExtraLight}`,
    lightBackground: p => p.tertiaryExtraLight,
    icon: p => p.primaryLight,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
